import { Component, OnInit } from "@angular/core";
import { switchMap } from "rxjs/operators";

import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { AtualizacaoInfoRiscoService } from "../atualizacao-info-risco.service";
import { EntradaAtualizacaoInformacoesOperacao, 
         EntradaLoteAtualizacaoInformacoesOperacao } from "src/app/model/entrada-atualizacao-informacoes-operacao.model";
import { SaidaAtualizacaoInformacoesOperacao } from "src/app/model/saida-lote-atualizacao-informacoes-operacao.model";
import { MessageChannelService, messageLevel, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Router } from "@angular/router";
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';
import { ProtocoloArquivoService } from '../../../../shared/services/protocolo-arquivo.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';

@Component({
    templateUrl: './atualizacao-info-risco-cadastro.component.html',
    styleUrls: ['./atualizacao-info-risco-cadastro.component.scss'],
    standalone: false
})
export class AtualizacaoInfoRiscoCadastroComponent implements OnInit {
    public classificacoesRisco: string[] = ["AA", "A", "B", "C", "D", "E", "F", "G", "H", "HH"];
    public entradas: EntradaAtualizacaoInformacoesOperacao[] = null;
    public saidas: SaidaAtualizacaoInformacoesOperacao[] = null;
    public modoEdicao: boolean;
    public limiteOperacoesCadastroViaTela = 250;
    public ocorrencias: OcorrenciaValidacaoVO[] = [];

    constructor(
        private atualizacaoService: AtualizacaoInfoRiscoService,
        private usuarioLogado: BnUsuarioService,
        private messageService: MessageChannelService,
        private router: Router,
        private protocoloArquivoService: ProtocoloArquivoService,
        private bnLoadingService: BnLoadingService
    ) { }

    ngOnInit(): void {
        this.modoEdicao = true;
        this.usuarioLogado.usuario$.pipe(
            switchMap(usuario => {
                return this.atualizacaoService.getOperacoesQuePrecisamSerAtualizadas(usuario.cnpj);
            }) 
        ).subscribe(resp => {
            this.entradas = (resp as any).operacoes.map(this.saidaParaEntradaConverter);
        });

    }
    
    liquidada(i:number){
        this.entradas[i].liquidada = this.entradas[i].liquidada==='S' ? 'N':'S';
    }

    private preencheOcorrencias(csv: string) {
        let linhas = csv.split("\n");

        let primeiraLinha: boolean = true;

        for (let linha of linhas) {
            if (primeiraLinha) {
                primeiraLinha = false;
                continue;
            }
            let campos = linha.split(";");
            if (campos.length == 4 && campos[3].length > 0) {
                let ocorrencia = new OcorrenciaValidacaoVO(campos[3], 'E', campos[1].length ? campos[1] + " " + campos[2] : campos[0]);
                this.ocorrencias.push(ocorrencia);
            }
        }
    }

    private monitorarResultado(tentativa, idProtocolo) {
        this.protocoloArquivoService.statusSolicitacao(idProtocolo).subscribe ((status) => {
           if (status != 'AGUARDANDO_VALIDACAO') {
                this.bnLoadingService.liberaTela();
                this.protocoloArquivoService.getArquivoRespostaCsv(idProtocolo).subscribe ( 
                    (csv) => {
                        if (status == 'SUCESSO') {
                            this.modoEdicao = false;

                            const mensagemSucesso = `Protocolo realizado com sucesso. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Sucesso',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.SUCCESS,
                                message: mensagemSucesso
                                });
                        }
                        else if (status == 'ERRO') {
                            this.preencheOcorrencias(csv);

                            const mensagemErro = `Protocolo realizado com erro. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                        else if (status == 'SUBSTITUIDO') {
                            const mensagemErro = `Protocolo substituído. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                        else if (status == 'EXCLUIDO') {
                            const mensagemErro = `Protocolo excluído. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                        else {
                            const mensagemErro = `Protocolo com status inválido. Id de protocolo: ${idProtocolo}`;

                            this.messageService.addMessage({
                                title: 'Erro',
                                type: 'CRUD_OPERATION',
                                level: messageLevel.ERROR,
                                message: mensagemErro
                                });
                        }
                    });
           }
           else {
               if (tentativa > 100) {
                const mensagemErro = `Tempo de resposta excedido. Utilize a tela de consulta de arquivos para ver o resultado. Id de protocolo: ${idProtocolo}`;

                this.messageService.addMessage({
                    title: 'Erro',
                    type: 'CRUD_OPERATION',
                    level: messageLevel.ERROR,
                    message: mensagemErro
                    });
               }
               else {
                setTimeout(() => this.monitorarResultado(tentativa+1, idProtocolo), 5000);
               }
           }
        });
    }

    enviar(){
        this.ocorrencias = [];

        this.bnLoadingService.bloqueiaTela();

        this.atualizacaoService.enviarAtualizacoes(this.getLote()).subscribe(resp =>{
            const msgRetorno = (<MensagemRetornoAssincrono> resp);

            this.monitorarResultado(1, msgRetorno.idProtocolo);
        });
    }

    private getLote(){
        let lote:EntradaLoteAtualizacaoInformacoesOperacao = {
            operacoes: this.entradasComBooleanosComoStrings()
        };
        return lote;
    }

    private entradasComBooleanosComoStrings(): EntradaAtualizacaoInformacoesOperacao[] {
        let result: EntradaAtualizacaoInformacoesOperacao[] = [];

        for (let entrada of this.entradas) {

            let copia = {...entrada};
            copia.liquidada = copia.liquidada == 'S' ? 'S' : 'N';
            copia.riscoOperacao = entrada.riscoOperacao;
            
            result.push(copia);
        }

        return result;
    }

    private saidaParaEntradaConverter(saida: SaidaAtualizacaoInformacoesOperacao): EntradaAtualizacaoInformacoesOperacao {
        let entrada: EntradaAtualizacaoInformacoesOperacao = {
            idOperacaoAgenteCreditoLivre: saida.idOperacaoAgenteCreditoLivre,
            contratoRepasse: saida.contratoRepasse,
            sistemaRepasse: saida.sistemaRepasse
        };

        return entrada;
    }
    
    cancelar() {
        this.router.navigate(['/atualizacao-info-risco/pesquisa']);
    }
}